import { store as apolloStore } from '../../app/apollo-client-instance';
import { remote } from '../../store/operations';
import { reduxStore } from './index';

const initEligibility = ({ eligible, moveType }) => ({
  type: 'INIT_ELIGIBILITY',
  eligible,
  moveType,
});

const _requestMoveIqEligibility = (dispatch, getState) => {
  const { loadingEligibility } = getState();
  if (!loadingEligibility) {
    // We enter this scenario if the user re-engages
    // We may want to consider, therefore, handling eligibility error differently
    // We can also enter this if we attempt tp requestMoveIqEligibility multiple times
    // Currently, we only do so once when the app instantiates.
    return;
  }
  // TODO: Consider optimizing from localStorage if the user has already engaged
  // And already have had requested eligibility. Right now, we don't cache it
  // So we don't accidentally hold on to eligibility error forever.
  apolloStore()
    .mutate(remote.evaluateMoveIqEligibility())
    .then(result => {
      try {
        const {
          data: {
            evaluateMoveIqEligibility: { eligible, moveType },
          },
        } = result;
        dispatch(
          initEligibility({
            eligible,
            moveType,
            moveTypes: moveType ? [moveType.toUpperCase()] : [],
          })
        );
      } catch (ex) {
        dispatch(initEligibility({ ...getState(), eligible: 'error' }));
      }
    })
    .catch(() => {
      dispatch(initEligibility({ ...getState(), eligible: 'error' }));
    });
};

export const requestMoveIqEligibility = () => _requestMoveIqEligibility;

export const getReduxEligibility = () =>
  new Promise(resolve => {
    const { loadingEligibility } = reduxStore().getState();
    if (loadingEligibility) {
      const unsubscribe = reduxStore().subscribe(() => {
        const { loadingEligibility } = reduxStore().getState();
        if (!loadingEligibility) {
          unsubscribe();
          resolve(reduxStore().getState());
        }
      });
    } else {
      resolve(reduxStore().getState());
    }
  });
